import { AxiosInstance } from "axios";
import { Address } from "../models/address";
import { Profile } from "../models/profile";
import { camelToSnake } from "@/lib/objects";

const PROFILE_API_PREFIX = "/profiles";

export async function getProfile(
	http: AxiosInstance
): Promise<{ profile: Profile; address: Address }> {
	const response = await http.get(PROFILE_API_PREFIX);
	return response.data;
}

export async function updateProfile(
	http: AxiosInstance,
	firstName: string,
	lastName: string,
	streetAddress: string,
	mobileNumber: string,
	city: string,
	stateId: string,
	zipCode: string,
	image?: File
) {
	const formData = new FormData();

	if (image) {
		formData.append("image", image);
	}

	formData.append(
		"update_profile_request",
		JSON.stringify(
			camelToSnake({
				firstName,
				lastName,
				streetAddress,
				mobileNumber,
				city,
				stateId,
				zipCode,
			})
		)
	);

	const response = await http.put(PROFILE_API_PREFIX, formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

	return response.data;
}

export type BillingAddressPayload = {
	line1: string;
	line2?: string;
	city: string;
	state: string;
	postalCode: string;
	country?: string;
	phone?: string;
};

export async function saveBillingAddress(
	http: AxiosInstance,
	payload: BillingAddressPayload
) {
	const response = await http.put(
		`${PROFILE_API_PREFIX}/billing-address`,
		payload
	);
	return response.data;
}
